import ImovelAPI from 'dashboard/api/imoveis';
import { createStore } from 'dashboard/store/storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';
import camelcaseKeys from 'camelcase-keys';

export const useImoveisStore = createStore({
  name: 'imoveis',
  type: 'pinia',
  API: ImovelAPI,
  getters: {
    getImoveisList: state => camelcaseKeys(state.records, { deep: true }),
  },
  actions: () => ({
    async importXml(payload) {
      this.setUIFlag({ creatingItem: true });
      try {
        const { data } = await ImovelAPI.importXml(payload);
        return data;
      } catch (error) {
        throwErrorMessage(error);
      } finally {
        this.setUIFlag({ creatingItem: false });
      }
      return null;
    },
  }),
});
